import { z } from 'zod';

export const countrySchema = z.enum([
  'saudi_arabia',
  'united_arab_emirates',
  'jordan',
  'egypt',
  'syria',
  'kuwait',
  'other',
]);
export type Country = z.infer<typeof countrySchema>;
const country = countrySchema.Enum;

export const countriesSupportedSchema = z.enum([country.saudi_arabia]);
/** the current countries that our app operates in */
export type CountriesSupported = z.infer<typeof countriesSupportedSchema>;
